export function controllerDefinitionBuilder() {
  const definitions = [];
  const get = () => definitions;

  const newRow = () => {
    definitions.push({ type: 'grid-row-break' });
    return { addControllerConfig, get };
  };

  const addControllerConfig = definition => {
    definitions.push(definition);
    return { addControllerConfig, get, newRow };
  };
  return { addControllerConfig };
}
